import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "universal-cookie";
import { getQuiz } from "../config/ListLesson";
import {
  createNewPractices,
  getAPracticeQuestion,
  submitPracticeQuestionAnswers
} from "../config/practiceQuestion";
import { getAQuestion } from "../config/question";

const initialState = {
  questions: null,
  seenQuestions: 0,
  correctAnswers: 0,
  wrongAnswers: 0,
  skippedQuestions: 0,
  status: "idle",
  error: null,
  quizInformation: null,
  createNewPractice: null,
  answeredQuestions: [],
  newPracticeId: null,
};

export const fetchPracticeQuestions = createAsyncThunk(
  "practiceQuestion/fetchPracticeQuestions",
  async () => {
    // TODO: Change this to the actual API endpoint
    const { data } = await axios.get("mock-lesson-data/practice.json");
    return data;
  }
);

export const getQuizInformation = createAsyncThunk(
  "practiceQuestion/getQuizInformation",
  async ({ quizId, token }, thunkAPI) => {
    try {
      const { result } = await getQuiz(quizId);
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.errorMessage);
    }
  }
);

export const createNewPractice = createAsyncThunk(
  "practiceQuestion/createNewPractice",
  async ({ practiceId }, thunkAPI) => {
    try {
      const { result } = await createNewPractices(practiceId);
      const cookies = new Cookies()
      cookies.set("newPracticeId", result)
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.errorMessage);
    }
  }
);

export const getAPracticeQuestions = createAsyncThunk(
  "practiceQuestion/getAPracticeQuestion",
  async (
    { practiceQuizIdLP, practiceQuizId, newPracticeId, token},
    thunkAPI
  ) => {
    var id = "";

    if (practiceQuizIdLP) {
      id = practiceQuizIdLP;
    } else if (practiceQuizId) {
      id = practiceQuizId;
    } else {
      id = newPracticeId;
    }

    try {
      const { result } = await getAPracticeQuestion(id, token);

      if (practiceQuizIdLP) {
        result.records.map((record) => (record.question.showSolution = true));
      }
      if (result.questions?.some((question) => !question.question)) {
        var listQuestion = await axios.all(
          result.questions.map(async (questionItem) => {
            const { result } = await getAQuestion(questionItem.questionId,token);
            questionItem = {
              ...questionItem,
              explanation: result.explanation,
              prompt: result.prompt,
              question: result.question,
              type: result.type,
            };
            return questionItem;
          })
        );
        result.questions = listQuestion;
      }

      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.errorMessage);
    }
  }
);

export const submitAnswers = createAsyncThunk(
  "practiceQuestion/submitAnswers",
  async ({ practiceQuizId, submit  }, thunkAPI) => {
    try {
      const { result } = await submitPracticeQuestionAnswers(
        practiceQuizId,
        submit
      );
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.errorMessage);
    }
  }
);

export const practiceQuestion = createSlice({
  name: "practiceQuestion",
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setQuestionVisible: (state, action) => {
      if (state.questions[action.payload - 1].isLast) {
        return;
      } else {
        state.questions[action.payload].visible = true;
      }
    },
    setQuestionState: (state, action) => {
      state.questions[action.payload.index].question.state =
        action.payload.state;
    },
    setQuestionsAnswered: (state, action) => {
      state.answeredQuestions = action.payload;
      for (var i = 0; i < action.payload.length; i++) {
        if (action.payload[i]) {
          state.questions[action.payload[i].questionIndex].answer =
            action.payload[i].answer;
        }
      }
    },

    clearQuizState: (state) => {
      state.quizInformation = null;
    },

    clearState: (state) => {
      state.questions = null;
      state.createNewPractice = null;
      state.answeredQuestions = [];
      state.newPracticeId = null;
      state.getQuizInformation = []
    },

    setQuestionAnswered: (state, action) => {
      state.questions[action.payload.questionIndex].isAnswered =
        action.payload.status;
    },

    setSeenQuestions: (state, action) => {
      state.seenQuestions = action.payload;
    },
    setQuestionFinished: (state, action) => {
      state.questions[action.payload].isFinished = true;
    },
    setSkippedQuestions: (state, action) => {
      state.skippedQuestions = action.payload + state.skippedQuestions;
    },
    setCorrectAnswer: (state, action) => {
      state.correctAnswers = action.payload + state.correctAnswers;
    },
    setWrongAnswer: (state, action) => {
      state.wrongAnswers = action.payload + state.wrongAnswers;
    },

    setQuizInformation: (state, action) => {
      state.getQuizInformation = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPracticeQuestions.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPracticeQuestions.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.questions = action.payload.result.records;
        state.correctAnswers = action.payload.result.correctAnswers;
        state.wrongAnswers = action.payload.result.wrongAnswers;
        state.skippedQuestions = action.payload.result.skippedQuestions;
        state.questions[state.questions.length - 1].isLast = true;
        state.seenQuestions =
          action.payload.result.seenQuestions === 0
            ? 1
            : action.payload.result.seenQuestions;
        state.questions[0].visible = true;
        state.questions.forEach((question, index) => {
          question.questionIndex = index;
        });
        state.questions
          .filter((question, index) => index < state.seenQuestions)
          .forEach((question) => {
            question.done = true;
            question.visible = true;
          });
      })
      .addCase(fetchPracticeQuestions.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getAPracticeQuestions.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getAPracticeQuestions.fulfilled, (state, action) => {
        state.questions = action.payload.records
          ? action.payload.records
          : action.payload.questions;
        state.correctAnswers = action.payload.correctAnswers;
        state.wrongAnswers = action.payload.wrongAnswers;
        state.skippedQuestions = action.payload.skippedQuestions;
        state.seenQuestions =
          action.payload.seenQuestions === 0 ? 1 : action.payload.seenQuestions;
        state.questions[state.questions.length - 1].isLast = true;
        state.questions[0].visible = true;
        state.questions.forEach((question, index) => {
          question.questionIndex = index;
          if (question.question.showSolution) {
            question.isCorrect =
              question?.answer !== null &&
              question?.answer?.length > 0 &&
              question.answer.every(
                (item, index) => item === question.question.solutions[index]
              );
          } else {
            question.isAnswered =
              question?.answer !== null && question?.answer?.length > 0;
          }
        });
        state.questions
          .filter((question, index) => index < state.seenQuestions)
          .forEach((question) => {
            question.done = true;
            question.visible = true;
          });
      })
      .addCase(getAPracticeQuestions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(getQuizInformation.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.quizInformation = action.payload;
      })
      .addCase(createNewPractice.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.newPracticeId = action.payload;
      })
      .addCase(submitAnswers.fulfilled, (state, action) => {
        state.status = "succeeded";
      });
  },
});

export const {
  setStatus,
  setQuestionVisible,
  setQuestionState,
  setSeenQuestions,
  setCorrectAnswer,
  setSkippedQuestions,
  setWrongAnswer,
  setQuestionFinished,
  setQuizInformation,
  setQuestionsAnswered,
  clearState,
  clearQuizState,
  setQuestionAnswered,
} = practiceQuestion.actions;

export const selectQuestions = (state) => state.practiceQuestion.questions;
export const selectAnsweredQuestions = (state) =>
  state.practiceQuestion.answeredQuestions;
export const selectStatus = (state) => state.practiceQuestion.status;

export default practiceQuestion.reducer;
